import React from 'react';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V2/Button/Button';

interface MembershipSuccessProps {
    membershipName: string;
    onClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 16,
            width: '100%',
            height: '100%',
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        icon: {
            width: 90,
            height: 90,
            fontSize: 40,
            display: 'flex',
            color: '#ffffff',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#5E8677',
            borderRadius: 100
        },
        title: {
            fontSize: 32,
            lineHeight: 1.2,
            fontWeight: 600
        },
        description: {
            'fontSize': 15,
            'lineHeight': 1.4,
            'fontWeight': 400,

            '& b': {
                fontWeight: 600
            }
        }
    })
);

export const MembershipSuccess: React.FC<MembershipSuccessProps> = props => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.icon}>
                <FontAwesomeIcon icon={faCheck} />
            </div>

            <div>
                <Typography className={classes.title}>Good Job</Typography>
                <Typography className={classes.description}>
                    <b>{props.membershipName}</b> was added succesfully.
                </Typography>
            </div>

            <Button
                size="large"
                variant="black"
                label="Go to Memberships"
                onClick={props.onClose}
            />
        </div>
    );
};
